<template>
  <DropDown v-if="$beet.isReady" :is-open="isOpen" class="mobile-nav">
    <div class="mobile-nav__content">
      <header class="mobile-nav__header">
        <h4 class="mobile-nav__title">Menu</h4>
        <LangSwitchLink />
      </header>

      <menu>
        <MobileNavItem
          :item="item"
          :hashes="hashes"
          v-for="(hashes, item) in $store.state.navigation.main"
          :key="item"
        />

        <LangRouterLink
          :to="{ name: 'contact', hash: '#map' }"
          tag="button"
          class="mobile-nav__button button -link -border -link"
          @click.native="$emit('close')"
        >
          <Icon id="map-pin" class="button__icon" />
          <span>{{ $t('find_a_location') }}</span>
        </LangRouterLink>

        <LangRouterLink
          :to="{ name: 'contact' }"
          tag="button"
          class="mobile-nav__button button -link"
          @click.native="$emit('close')"
        >
          <Icon id="mail" class="button__icon" />
          <span>{{ $t('contact_us') }}</span>
        </LangRouterLink>
      </menu>

      <nav class="mobile-nav__legal">
        <LangRouterLink
          v-for="key in $store.state.navigation.policies"
          :key="`mobile-policies-${key}`"
          :to="{ name: key }"
          class="mobile-nav__link"
          @click.native="$emit('close')"
        >
          {{ $t(`policies.${key}`) }}
        </LangRouterLink>
      </nav>

      <nav class="mobile-nav__social">
        <a
          v-for="(url, name) in $beet.options.socials"
          :key="`mobile-nav-${name}`"
          :href="url"
          target="_blank"
          rel="noopener"
          class="mobile-nav__social-link"
        >
          <Icon v-if="url" :id="name" />
        </a>
      </nav>
    </div>
  </DropDown>
</template>

<script>
import DropDown from '@/components/global/DropDown.vue'
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import LangSwitchLink from '@/components/nav/LangSwitchLink.vue'
import MobileNavItem from '@/components/nav/MobileNavItem.vue'

export default {
  name: 'MobileNav',
  components: { LangSwitchLink, MobileNavItem, Icon, DropDown, LangRouterLink },
  props: {
    isOpen: { type: Boolean, default: false },
  },
  watch: {
    isOpen(isOpen) {
      if (isOpen && !document.body.classList.contains('--lock')) {
        document.body.classList.add('--lock')
      } else if (!isOpen && document.body.classList.contains('--lock')) {
        document.body.classList.remove('--lock')
      }
    },
    $route: {
      handler() {
        this.$emit('close')
      },
      deep: true,
    },
  },
}
</script>
